/*
 * Gift with purchase (Theme settings > Gift with purchase; config from
 * snippets/gift-tiers-config.liquid).
 *
 * sync() makes the cart hold exactly one of each gift the cart has earned, marked
 * with the hidden line property _gift, and nothing else from the gift products.
 * Lines marked _gift that no enabled tier gives (gift with purchase or a tier was
 * switched off) are removed, so with no tiers this only clears leftover gifts.
 * The qualifying amount is the cart's pre-discount subtotal, ignoring the gifts.
 *
 * The cart drawer calls sync() after every cart change. On the cart page, which has
 * no drawer, this script watches cart requests itself and reloads the page when it
 * changes the gifts. Its own requests carry ?ss_internal=1 so watchers ignore them.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('GiftTiersConfig');
  if (!configEl || window.SSGifts) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!config.tiers) return;

  var INTERNAL = 'ss_internal=1';
  var CART_REQUEST = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var giftVariants = {};
  config.tiers.forEach(function (tier) {
    tier.variants.forEach(function (id) { giftVariants[id] = true; });
  });

  function post(path, payload) {
    return window.fetch(root + path + '?' + INTERNAL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Gift update failed');
      return response.json();
    });
  }

  function qualifyingSubtotal(cart) {
    return cart.items.reduce(function (sum, item) {
      return giftVariants[item.variant_id] ? sum : sum + item.original_line_price;
    }, 0);
  }

  function isMarkedGift(item) {
    return !!(item.properties && item.properties._gift);
  }

  var running = null;
  var again = false;

  function runSync() {
    return window.fetch(root + 'cart.js?' + INTERNAL, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var subtotal = qualifyingSubtotal(cart);
        var wanted = {};
        config.tiers.forEach(function (tier) {
          if (subtotal >= tier.threshold) {
            tier.variants.forEach(function (id) { wanted[id] = true; });
          }
        });

        var kept = {};
        var removals = {};
        var removing = false;
        cart.items.forEach(function (item) {
          if (!giftVariants[item.variant_id] && !isMarkedGift(item)) return;
          var keep = wanted[item.variant_id] && !kept[item.variant_id] && item.quantity === 1 && isMarkedGift(item);
          if (keep) {
            kept[item.variant_id] = true;
          } else {
            removals[item.key] = 0;
            removing = true;
          }
        });

        var additions = Object.keys(wanted).filter(function (id) { return !kept[id]; }).map(function (id) {
          return { id: parseInt(id, 10), quantity: 1, properties: { _gift: 'Free gift' } };
        });

        if (!removing && !additions.length) return false;

        var steps = Promise.resolve();
        if (removing) steps = steps.then(function () { return post('cart/update.js', { updates: removals }); });
        if (additions.length) {
          // A sold-out gift fails the whole add; retry one at a time so the others still go in.
          steps = steps.then(function () {
            return post('cart/add.js', { items: additions }).catch(function () {
              return additions.reduce(function (chain, item) {
                return chain.then(function () { return post('cart/add.js', { items: [item] }).catch(function () {}); });
              }, Promise.resolve());
            });
          });
        }
        return steps.then(function () { return true; });
      });
  }

  // Resolves to true if the gifts in the cart changed. Calls made while a sync is
  // running share one follow-up sync, so the last cart state always gets checked.
  function sync() {
    if (running) {
      again = true;
      return running;
    }
    running = runSync()
      .catch(function () { return false; })
      .then(function (changed) {
        running = null;
        if (!again) return changed;
        again = false;
        return sync().then(function (changedAgain) { return changed || changedAgain; });
      });
    return running;
  }

  window.SSGifts = { sync: sync };

  if (config.cartPage) {
    var timer = null;
    var check = function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        sync().then(function (changed) { if (changed) window.location.reload(); });
      }, 150);
    };
    if ('PerformanceObserver' in window) {
      try {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (entry) {
            if (entry.initiatorType !== 'fetch' && entry.initiatorType !== 'xmlhttprequest') return;
            if (entry.name.indexOf(INTERNAL) !== -1) return;
            if (CART_REQUEST.test(entry.name)) check();
          });
        }).observe({ type: 'resource' });
      } catch (e) {}
    }
    check();
  } else if (!window.SSCartDrawer && !document.getElementById('CartDrawer')) {
    // No drawer on this page: still correct the gifts once on load.
    sync();
  }
})();
